export interface PresetBank {
  name: string;
  items: string[];
}

export const CHARADES: PresetBank[] = [
  {
    name: "Animals",
    items: [
      "Elephant",
      "Kangaroo",
      "Penguin",
      "Snake",
      "Monkey",
      "Frog",
      "Crab",
      "Butterfly",
      "Horse",
      "Owl",
    ],
  },
  {
    name: "Actions",
    items: [
      "Brushing teeth",
      "Riding a bike",
      "Swimming",
      "Painting",
      "Sneezing",
      "Tying shoes",
      "Juggling",
      "Dancing",
    ],
  },
  {
    name: "Movies",
    items: [
      "The Lion King",
      "Frozen",
      "Finding Nemo",
      "Toy Story",
      "Jurassic Park",
      "Harry Potter",
      "Paddington",
    ],
  },
  {
    name: "Objects",
    items: [
      "Umbrella",
      "Toothbrush",
      "Kettle",
      "Backpack",
      "Guitar",
      "Telescope",
      "Vacuum cleaner",
      "Skateboard",
    ],
  },
  {
    name: "School",
    items: [
      "Reading a book",
      "Raising your hand",
      "Sharpening a pencil",
      "Lining up",
      "Taking a test",
      "Recess",
    ],
  },
];

export const PICTIONARY: PresetBank[] = [
  {
    name: "Easy",
    items: ["Sun", "House", "Cat", "Tree", "Boat", "Star", "Apple", "Fish", "Hat", "Cloud"],
  },
  {
    name: "Medium",
    items: ["Lighthouse", "Volcano", "Robot", "Playground", "Rainbow", "Campfire", "Windmill"],
  },
  {
    name: "Hard",
    items: ["Gravity", "Recycling", "Photosynthesis", "Democracy", "Time travel", "Earthquake"],
  },
  {
    name: "School",
    items: ["Whiteboard", "Locker", "School bus", "Library", "Science lab", "Lunch tray"],
  },
];

export const WOULD_YOU_RATHER: PresetBank[] = [
  {
    name: "Classroom",
    items: [
      "Would you rather have no homework for a month or an extra recess every day?",
      "Would you rather write with a giant pencil or a tiny one?",
      "Would you rather read one book 100 times or 100 books once?",
      "Would you rather learn every instrument or every language?",
    ],
  },
  {
    name: "Silly",
    items: [
      "Would you rather have fingers as long as your legs or legs as long as your fingers?",
      "Would you rather sneeze glitter or burp bubbles?",
      "Would you rather talk like a robot or sing every sentence?",
      "Would you rather be able to fly slowly or run super fast?",
    ],
  },
  {
    name: "Adventure",
    items: [
      "Would you rather explore space or the deep ocean?",
      "Would you rather live in a treehouse or an underground base?",
      "Would you rather travel to the past or the future?",
      "Would you rather tame a dragon or train a giant eagle?",
    ],
  },
];

export const TRIVIA: PresetBank[] = [
  {
    name: "Science",
    items: [
      "How many planets are in our solar system?",
      "What gas do plants absorb from the air?",
      "What is the largest organ of the human body?",
      "Water freezes at what temperature in Celsius?",
    ],
  },
  {
    name: "Geography",
    items: [
      "What is the longest river in the world?",
      "Which continent is the Sahara Desert on?",
      "What is the capital of Japan?",
      "Which ocean is the largest?",
    ],
  },
  {
    name: "Maths",
    items: [
      "What is 7 x 8?",
      "How many sides does a hexagon have?",
      "What is half of 250?",
      "What is 15% of 200?",
    ],
  },
  {
    name: "General",
    items: [
      "How many days are in a leap year?",
      "Who wrote Romeo and Juliet?",
      "How many colours are in a rainbow?",
      "What is the fastest land animal?",
    ],
  },
];

export const CHALLENGES: PresetBank[] = [
  {
    name: "Classroom safe",
    items: [
      "Say the alphabet backwards in 20 seconds",
      "Balance a book on your head for 15 seconds",
      "Name 5 countries in 10 seconds",
      "Give a 10-second speech about your favourite food",
      "Do your best animal impression",
      "Spell your name with your elbow in the air",
    ],
  },
  {
    name: "Movement",
    items: [
      "10 star jumps",
      "Hold a tree pose for 20 seconds",
      "Tiptoe walk across the room",
      "Do 5 slow squats",
    ],
  },
];

export const BRAIN_BREAKS: PresetBank[] = [
  {
    name: "Quick moves",
    items: [
      "20 seconds of star jumps",
      "Stretch tall, then touch your toes",
      "Shake out both hands for 10 seconds",
      "Silent dance party for 30 seconds",
      "Simon Says for one minute",
    ],
  },
  {
    name: "Calm down",
    items: [
      "Four rounds of box breathing",
      "Close your eyes and count 10 breaths",
      "Roll your shoulders slowly 5 times",
      "Describe something you can see, hear and feel",
    ],
  },
];

export const ACTIVITIES: PresetBank[] = [
  {
    name: "Warm-ups",
    items: [
      "Think-pair-share",
      "Quick quiz",
      "Word of the day",
      "Two truths and a lie",
      "Mind map on the board",
    ],
  },
  {
    name: "Group work",
    items: [
      "Jigsaw reading",
      "Poster challenge",
      "Role play",
      "Debate the topic",
      "Build a quiz for another team",
    ],
  },
  {
    name: "Wrap-ups",
    items: [
      "Exit ticket",
      "One thing I learned",
      "Draw the lesson",
      "Teach your partner",
      "Rate your confidence",
    ],
  },
];

export const QUESTIONS: PresetBank[] = [
  {
    name: "Get to know you",
    items: [
      "What is your favourite subject and why?",
      "What is one thing you are proud of this week?",
      "If you could teach the class anything, what would it be?",
      "What helps you focus best?",
    ],
  },
  {
    name: "Comprehension",
    items: [
      "Can you summarise that in one sentence?",
      "What evidence supports your answer?",
      "How would you explain this to a younger student?",
      "What might happen next, and why?",
    ],
  },
];

export const WORDS: PresetBank[] = [
  {
    name: "Everyday",
    items: [
      "garden",
      "window",
      "bicycle",
      "letter",
      "pocket",
      "candle",
      "mirror",
      "basket",
      "ticket",
      "bridge",
    ],
  },
  {
    name: "Spelling",
    items: [
      "necessary",
      "rhythm",
      "separate",
      "definitely",
      "occasion",
      "believe",
      "island",
      "friend",
      "because",
    ],
  },
  {
    name: "Adjectives",
    items: [
      "curious",
      "gentle",
      "brave",
      "gigantic",
      "shiny",
      "peaceful",
      "clever",
      "noisy",
      "ancient",
      "fragile",
    ],
  },
];

export const CHOICES: PresetBank[] = [
  { name: "Yes / No / Maybe", items: ["Yes", "No", "Maybe"] },
  { name: "Options", items: ["Option A", "Option B", "Option C", "Option D"] },
  { name: "Order", items: ["First", "Second", "Third", "Last"] },
];

export const COLORS: { name: string; hex: string }[] = [
  { name: "Crimson", hex: "#DC2626" },
  { name: "Tangerine", hex: "#F97316" },
  { name: "Sunflower", hex: "#FACC15" },
  { name: "Lime", hex: "#84CC16" },
  { name: "Emerald", hex: "#10B981" },
  { name: "Teal", hex: "#14B8A6" },
  { name: "Sky", hex: "#0EA5E9" },
  { name: "Indigo", hex: "#6366F1" },
  { name: "Violet", hex: "#8B5CF6" },
  { name: "Fuchsia", hex: "#D946EF" },
  { name: "Rose", hex: "#F43F5E" },
  { name: "Slate", hex: "#64748B" },
  { name: "Chocolate", hex: "#92400E" },
  { name: "Mint", hex: "#6EE7B7" },
];

export const CLASSROOM_JOBS = [
  "Line Leader",
  "Door Holder",
  "Materials Helper",
  "Technology Helper",
  "Board Cleaner",
  "Class Monitor",
  "Librarian",
  "Messenger",
  "Plant Carer",
  "Paper Collector",
  "Tidy-up Captain",
  "Register Helper",
];
